import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import Separator from 'flarum/common/components/Separator';
import UserPage from 'flarum/forum/components/UserPage';
export default () => {
  extend(IndexSidebar.prototype, 'navItems', items => {
    if (app.forum.attribute('blomstraLinkAccessPortal') && app.forum.attribute('blomstraPaymentsPk')) {
      items.add('accessPortal', m(LinkButton, {
        icon: "fas fa-key",
        href: app.route('floxum-payments.access-portal')
      }, app.translator.trans('floxum-payments.forum.nav.access_portal')), 75);
    } else if (app.forum.attribute('blomstraLinkAccessPortal')) {
      console.error('No publishable key set for floxum/payments, access portal currently inaccessible.');
    }
  });
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    if (app.forum.attribute('blomstraPaymentsPk') && user && app.session.user === user) {
      items.add('separator-payments-subscriptions', m(Separator, null), -105);
      items.add('paymentsSubscriptions', m(LinkButton, {
        href: app.route('floxum-payments.user-payments', {
          username: user.slug()
        }),
        icon: "fas fa-store"
      }, app.translator.trans('floxum-payments.forum.nav.user_subscriptions')), -110);
    }
  });
};